import _ from 'lodash';
export function makePermissionHelpers(system) {
  function isPermissionType(value) {
    return system.permissionTypes.includes(value);
  }
  function isActionType(value) {
    return system.actionTypes.includes(value);
  }
  function tableToArray(permissionsTable) {
    const keyArray = [];
    for (const p of system.permissionTypes) {
      for (const a of system.actionTypes) {
        if (permissionsTable?.[p]?.[a]) {
          keyArray.push([p, a]);
        }
      }
    }
    return keyArray;
  }
  function getMetadata(permission, action) {
    return system.permissionsMetadata[permission]?.[action] ?? 'unused';
  }
  function compressTable(permissionsTable) {
    const result = {};
    for (const p of system.permissionTypes) {
      for (const a of system.actionTypes) {
        if (permissionsTable?.[p]?.[a]) {
          _.set(result, [p, a], true);
        }
      }
    }
    return result;
  }
  function combineTables(permissionsTables) {
    const result = {};
    for (const p of system.permissionTypes) {
      for (const a of system.actionTypes) {
        if (permissionsTables.some(pt => pt[p]?.[a])) {
          _.set(result, [p, a], true);
        }
      }
    }
    return result;
  }
  function normalizeTable(permissionsTable) {
    const result = {};
    for (const p of system.permissionTypes) {
      for (const a of system.actionTypes) {
        _.set(result, [p, a], permissionsTable?.[p]?.[a] ?? false);
      }
    }
    return result;
  }
  function isValidPermissionString(value) {
    const [p, a] = value.split(':');
    return isPermissionType(p) && isActionType(a) && system.permissionsMetadata[p][a] !== 'unused';
  }
  function hasAllPermissions(permissionsTable, permissionStrings) {
    // permissionStrings is something like ['Customers:create', 'Users:list']
    for (const permissionString of permissionStrings) {
      const [p, a] = permissionString.split(':');
      if (!isPermissionType(p)) {
        throw new Error(`${p} is not a recognized permission`);
      }
      if (!isActionType(a)) {
        throw new Error(`${a} is not a recognized permission action`);
      }

      // If the permission is marked as unused, then it is not required.
      if (system.permissionsMetadata[p]?.[a] === 'unused') {
        continue;
      }
      if (!permissionsTable?.[p]?.[a]) {
        return false;
      }
    }
    return true;
  }
  return {
    isPermissionType,
    isActionType,
    isValidPermissionString,
    getMetadata,
    tableToArray,
    compressTable,
    combineTables,
    normalizeTable,
    hasAllPermissions
  };
}